/** Human-readable transfer offer labels (investor UI). */

export function transferStatusLabel(status) {
  const s = String(status || "").toUpperCase();
  if (s === "PENDING") return "Pending";
  if (s === "COMPLETED") return "Fulfilled";
  if (s === "PARTIALLY_COMPLETED") return "Partially fulfilled";
  if (s === "REJECTED") return "Cancelled";
  if (s === "CANCELLED") return "Cancelled";
  return s || "—";
}

export function transferStatusTone(status) {
  const s = String(status || "").toUpperCase();
  if (s === "PENDING") return "badge-PENDING";
  if (s === "COMPLETED") return "badge-APPROVED";
  if (s === "PARTIALLY_COMPLETED") return "badge-PENDING";
  if (s === "REJECTED" || s === "CANCELLED") return "badge-REJECTED";
  return "badge";
}

export function transferSettlementLabel(status) {
  const s = String(status || "").toUpperCase();
  if (s === "PENDING") return "Settlement pending";
  if (s === "SETTLED") return "Settled";
  if (s === "FAILED") return "Settlement failed";
  if (s === "NOT_REQUIRED") return "—";
  return s || "—";
}
